import { render } from "./System.vue?vue&type=template&id=1c0a2b12&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"

import "./System.vue?vue&type=style&index=0&id=1c0a2b12&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0a2b12"]])

export default __exports__